import { locationTypeEnum } from "../../../../utils";

export function setAddressById(addresses: any) {
  const addressDetail: any = {};
  if (Array.isArray(addresses) && addresses.length > 0)
    addresses.forEach((address: any, index: number) => {
      switch (address.locationTypeId) {
        case locationTypeEnum.city:
          addressDetail.city = {
            value: address.turkTelekomId,
            label: address.name,
          };
          break;
        case locationTypeEnum.town:
          addressDetail.town = {
            value: address.turkTelekomId,
            label: address.name,
          };
          break;
        case locationTypeEnum.townShip:
          addressDetail.townShip = {
            value: address.turkTelekomId,
            label: address.name,
          };
          break;
        case locationTypeEnum.village:
          addressDetail.village = {
            value: address.turkTelekomId,
            label: address.name,
          };
          break;
        case locationTypeEnum.district:
          addressDetail.district = {
            value: address.turkTelekomId,
            label: address.name,
          };
          break;
        case locationTypeEnum.street:
          addressDetail.street = {
            value: address.turkTelekomId,
            label: address.name,
          };
          break;
        case locationTypeEnum.building:
          addressDetail.building = {
            value: address.turkTelekomId,
            label: address.name,
          };
          break;
        case locationTypeEnum.door:
          addressDetail.door = {
            value: address.turkTelekomId,
            label: address.name,
          };
          break;
        default:
          break;
      }
    });

  return addressDetail;
}
